import { render, staticRenderFns } from "./CourseSetting.vue?vue&type=template&id=6fa0fbd0"
import script from "./CourseSetting.js?vue&type=script&lang=js&external"
export * from "./CourseSetting.js?vue&type=script&lang=js&external"
import style0 from "./CourseSetting.vue?vue&type=style&index=0&id=6fa0fbd0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports